$(document).ready(function() {
  
  
    // featured product tab
    function handleTabSwitch(tab_id) {
      // Remove current class from all tabs & content
      $(".tabs-nav ul li").removeClass("current");
      $(".tab_section .tab_box").removeClass("current");
    
      // Add current class to tab content
      $("#" + tab_id).addClass("current");
    
      // Add current to corresponding tab button (if exists)
      $('.tabs-nav ul li[data-tab="' + tab_id + '"]').addClass("current");
    
      // Sync dropdown selection
      $(".mobile_tab_slider").val(tab_id);
    }
    
    // Desktop tab click
    $(document).on("click", ".tabs-nav ul li", function () {
      var tab_id = $(this).attr("data-tab");
      handleTabSwitch(tab_id);
    });
    
    // Mobile dropdown change
    $(document).on("change", ".mobile_tab_slider", function () {
      var tab_id = $(this).val();
      handleTabSwitch(tab_id);
    });

    //  featured product tab slider
    var swiper = new Swiper(".product_grid_slider", {
        slidesPerView: 4,
        grabCursor: true,
        observer: true,
        spaceBetween: 30,
        pagination: {
            el: ".product_grid_slider .swiper-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".product_grid_slider .button-next",
            prevEl: ".product_grid_slider .button-prev",
        },
        breakpoints: {
            320: {
                 autoHeight: true, 
                slidesPerView: 1,
            },
            480: {
                 autoHeight: true, 
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });

    //video tab
    function switchVideoTab(tabId) {
      $(".video_tabs li").removeClass("current");
      $(".video_main .video-tab-content").removeClass("current");
    
      // Add active class to tab content and tab button
      $('.video_tabs li[data-tabs="' + tabId + '"]').addClass("current");
      $("#" + tabId).addClass("current");
    
      // Sync dropdown (optional)
      $(".video_tabs_dropdown").val(tabId);
    }
    
    // Desktop tab click
    $(document).on("click", ".video_tabs li", function () {
      var tabId = $(this).attr("data-tabs");
      switchVideoTab(tabId);
    });
    
    // Mobile dropdown change
    $(document).on("change", ".video_tabs_dropdown", function () {
      var tabId = $(this).val();
      switchVideoTab(tabId);
    });



    //video tab Select 
    $(document).on("change", ".video_tabs_select ", function() {
        var tabId = $(this).find(":selected").attr("data-tabs"); 
        // alert(tabId);
        $(".video_tabs_select option").removeClass("current");
        $(".video_main .video-tab-content").removeClass("current");
        $(this).find(":selected").addClass("current");
        $("#" + tabId).addClass("current");
    });

    // video slider
    var swiper_video = new Swiper(".video_slider", {
        slidesPerView: 1,
        pagination: {
            el: ".video_slider .swiper-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".video_slider .button-next",
            prevEl: ".video_slider .button-prev",
        },
    });

    // Brand Slider
   // Check if the screen width is less than 768px (mobile)
var isMobile = window.innerWidth < 990;
// Set up base config
var swiperConfig = {
  slidesPerView: 2,
  grid: {
    rows: 2,
    fill: "row",
  },
  spaceBetween: 20,
  pagination: {
    el: ".itg_shop_brands_wr .swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".itg_shop_brands_wr .button-next",
    prevEl: ".itg_shop_brands_wr .button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 30,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 30,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
  }
};
// Add autoplay if on mobile
if (isMobile) {
  swiperConfig.autoplay = {
    delay: 0, 
    disableOnInteraction: false,
  };
  swiperConfig.speed = 2500; 
  swiperConfig.loop = true;
  swiperConfig.allowTouchMove = true; 
}
// Initialize Swiper
var swiper_brand = new Swiper(".shop_brands_imgs", swiperConfig);


    // Review Slider


    // mobile product slider
    if (window.outerWidth < 989) {
        var swiper_product = new Swiper(".product_grid", {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: ".product_grid .swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: ".product_grid .button-next",
                prevEl: ".product_grid .button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: 2,
                },
            },
        });

        // mobile collection section tab
      $(".collection_dropdown").change(function () {
        var tab_id = $(this).val();
      
        $(".collection_tabs li").removeClass("coll_current");
        $(".coll_list_main_item .tab-content").removeClass("coll_current");
      
        $('.tab-content[data-id="' + tab_id + '"]').addClass("coll_current");
        $('.collection_tabs li[data-coll="' + tab_id + '"]').addClass("coll_current");
      });
    }
    // MObile Tab in Footer links

    if (window.outerWidth < 750) {
        $(document).on(
            "click",
            ".footer-block--menu .footer-block__heading",
            function() {
                // $(this).addClass('active');
                var data_heading = $(this).attr("data-heading");
                $(this).toggleClass("transform");
                $(".footer-block--menu .footer-block__details-content").each(
                    function() {
                        var data_link = $(this).attr("data-link");
                        if (data_heading == data_link) {
                            $(this).slideToggle();
                        } else {
                            $(this).slideUp();
                            $(this).prev(".footer-block__heading").removeClass("transform");
                        }
                    }
                );
            }
        );
    }

    if (window.outerWidth > 990) {
        // var swiper_thumb = new Swiper(".thumb_slider", {
        //   slidesPerGroup: 1,
        //   loop:true,
        //   direction: "vertical",
        //   centeredSlides: true,
        //   centeredSlidesBounds: true,
        //   slidesPerView: 3,
        //   watchOverflow: true,
        //   watchSlidesVisibility: true,
        //   watchSlidesProgress: true,
        //  navigation: {
        //     nextEl: ".thumb_slider .s_btn_next",
        //     prevEl: ".thumb_slider .s_btn_prev",
        //   },
        //    breakpoints: {
        //      990: {
        //       slidesPerView:4 ,
        //     },
        //    },
        // });
    }

    // product description tab
    $(".description_tab li").click(function() {
        var d_id = $(this).attr("data-tab");

        $(".description_tab li").removeClass("active");
        $(".desc_content").removeClass("active");

        $(this).addClass("active");
        $("#" + d_id).addClass("active");
    });

     $(".description_tab_select").on("change", function () {
        var d_id = $(this).val();
    
        $(".desc_content").removeClass("active");
        $("#" + d_id).addClass("active");
      });

    // model ption show

    $(".all_option select").on("change", function() {
        var value = $(this).find("option:selected").val();
        $(".option_content").hide().removeClass("option_show");
        // alert(value);
        $(".option_content_main .option_content").each(function() {
            var dataValue = $(this).data("value");
            if (value == dataValue) {
                $(this).show().addClass("option_show");
            }
        });
    });

    $(".desc_content form#ContactForm").submit(function() {
        $(".option_content_main .option_show").each(function() {
            var checkValue = $(this).find("select option:selected").val();
            alert(checkValue);
            if (checkValue == "") {
                return false;
                $(this).addClass("error");
                return false;
            }
        });
    });

    // You Tube Lazy Load
    $(function() {
        $(".video_frame iframe[data-src]").Lazy();
        $(".bnr_cstm_vid iframe[data-src]").Lazy();
    });

    // Careers Page Slider
    var swiper_core = new Swiper(".core_value", {
        slidesPerView: 1,
        grid: {
            rows: 1,
            fill: "row",
        },
        spaceBetween: 20,
        pagination: {
            el: ".itg_shop_brands_wr .swiper-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".itg_shop_brands_wr .button-next",
            prevEl: ".itg_shop_brands_wr .button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 20,
                grid: {
                    rows: 1,
                    fill: "row",
                },
            },
            900: {
                slidesPerView: 1,
                spaceBetween: 20,
                grid: {
                    rows: 1,
                    fill: "row",
                },
            },
            1440: {
                slidesPerView: 1,
                spaceBetween: 30,
                grid: {
                    rows: 1,
                    fill: "row",
                },
            },
        },
    });

  // blog category search
    $("#myInput").on("keyup", function() {
        var value = $(this).val().toLowerCase();
        $(".blog_categries p").filter(function() {
            $(this).toggle(
                $(this).attr("data-value").toLowerCase().indexOf(value) > -1
            );
        });
    });

  // page category click scroll
    $(document).on("click", ".category_link p", function() {
        var handle = $(this).data("value");
        //alert(handle);
        $(".hd_pro_grids_main .hd_pro_head").each(function() {
            var getData = $(this).attr("data-title");
            if (handle == getData) {
                var position = ($(this).offset().top -= 150);
                $("HTML, BODY").animate({
                        scrollTop: position,
                    },
                    1200
                );
            }
        });
    });


  // On load Scroll in category 
      var link = window.location;
      var data = link.hash;
      var data = data.replace('#', '');
      if (data != ''){
      $(".hd_pro_grids_main .hd_pro_head").each(function() {
        var getData = $(this).attr("data-title");
        if (data == getData) {
            var position = ($(this).offset().top -= 100);
            $("HTML, BODY").animate({
                    scrollTop: position,
                },
                800
            );
        }
      });
      }

  
// megamenu scroll
      $(document).on("click", ".third_mega_list li a", function(e) {
        var handle = $(this).data("value");
       // alert(handle);
       //  e.preventDefault();
        //alert(handle);
        $(".hd_pro_grids_main .hd_pro_head").each(function() {
            var getData = $(this).attr("data-title");
            if (handle == getData) {
                var position = ($(this).offset().top -= 150);
                $("HTML, BODY").animate({
                        scrollTop: position,
                    },
                    1200
                );
            }
        });
    });


  
  // scroll top Button
    var btn = $("#top_button");
    $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
            btn.addClass("show");
        } else {
            btn.removeClass("show");
        }
    });

    btn.on("click", function(e) {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: 0
        }, "300");
    });

  // account page tab
    $(".account_tabs .tab_links").click(function() {
        var tab_id = $(this).attr("data-tab");
        $(".account_tabs .tab_links").removeClass("current");
        $(".account_content .tab-content").removeClass("current");
        $(this).addClass("current");
        $("#" + tab_id).addClass("current");
    });


  // after account login Local storage set
    if ($(".handle_product-result").hasClass("account_active")) {
        const queryString = window.location.search;
        //  console.log(queryString);
        const urlParams = new URLSearchParams(queryString);
        var Url = urlParams.get("rq");
        localStorage.setItem("search_value", Url);
    }

    if (localStorage.getItem("search_value")) {
        var queryString = window.location.search;
        // alert(queryString);
        var mainData = localStorage.getItem("search_value");
        console.log(mainData);
        var data = mainData.split('~');
        var data_one = data[0].split('_');
        var data_two = data[1].split('_');
        var data_three = data[2].split('_');
        var data_three_with_s = data_three[1].split("-").join(" ");
        //  alert(data_three_with_s);
        $('.ymm_app .horizontal').not('.handle_product-result .ymm_app .horizontal,.temp_product .ymm_app .horizontal').html('<h2 id="ymm_label" style="display: block;">Your Vehicle : &nbsp;' + data_one[1] + ' Toyota ' + '&nbsp;' + data_two[1] + '&nbsp;' + data_three_with_s + '  </h2> <div> <a class="search_link_btn btns" href="/pages/product-result?rq=' + mainData + '"> Start Shopping For Your Toyota </a>  </div> <span class="remove_vehicle"><img src="https://cdn.shopify.com/s/files/1/0727/2287/4661/files/x_7.svg?v=1682411501" alt="icon"> Remove current vehicle </span>');
    } else {
        //alert("no");
    }

// remove local storeg
    $(document).on("click", ".remove_vehicle", function() {
        localStorage.removeItem("search_value");
        location.reload();
    });

// blog tab
	// $('ul.blog_tabs li').click(function(){
	// 	var tab_id = $(this).attr('data-tab');

	// 	$('ul.blog_tabs li').removeClass('current');
	// 	$('.tab-content_blog').removeClass('current');

	// 	$(this).addClass('current');
	// 	$("#"+tab_id).addClass('current');
	// });
	

		$('.blog_tab_one ul.blog_tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('.blog_tab_one ul.blog_tabs li').removeClass('current');
		$('.blog_tab_one .tab-content_blog').removeClass('current');

		$(this).addClass('current');
		$(".blog_tab_one #"+tab_id).addClass('current');
	});

  		$('.blog_tab_two ul.blog_tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('.blog_tab_two ul.blog_tabs li').removeClass('current');
		$('.blog_tab_two .tab-content_blog').removeClass('current');

		$(this).addClass('current');
		$(".blog_tab_two #"+tab_id).addClass('current');
	});

    $('.blog_tab_three ul.blog_tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('.blog_tab_three ul.blog_tabs li').removeClass('current');
		$('.blog_tab_three .tab-content_blog').removeClass('current');

		$(this).addClass('current');
		$(".blog_tab_three #"+tab_id).addClass('current');
	});
  
  // youtube video 
 $(document).on("click", ".youtube_video_main .video_item", function(ev) {
    $(this).addClass('active');
      $(this).find('.youtube_video_thumbs').hide();
      $(this).find('.video_hide').show();
       $(this).find('.video_hide')[0].src += "?&autoplay=1&mute=1";
  ev.preventDefault();
  });
  

// youtube data src 
   $(document).on("click", ".youtube_video_main .video_item.index_video_item", function(ev) {
      var dataSrc = $(this).attr('data-frame');
      $(this).find('.video_hide').attr('src',dataSrc);
      $(this).addClass('active');
      $(this).find('.youtube_video_thumbs').hide();
      $(this).find('.video_hide').show();
       $(this).find('.video_hide')[0].src += "?&autoplay=1&mute=1";
      ev.preventDefault();
  });

    // if (window.outerWidth < 750) {
    //   $('.blog_categries p a').attr("target", "_blank");
    // }

    if (window.location.href.indexOf("category_") > -1) {
      if (window.outerWidth < 989) {
        var position_new = ($('#blog__articles').offset().top - 60);
            $("HTML, BODY").animate({
            scrollTop: position_new,
        },
        500
        );
      }
    }  
});

// fancy box
$('[data-fancybox="gallery"]', {
  Thumbs: {
    type: "modern",
  },
});


// NEW Js

$(document).on('click', 'ul.menu-drawer__menu.list-menu .menu-drawer__menu-item', function(){
    var url = $(this).attr('href');
    url = url.includes('#');
    if (url) {
      console.log('yes')
      $(document).find('#Details-menu-drawer-container').find('.header__icon--menu').trigger('click'); 
    }
});


// blog toggle

    $(document).on('click', '.js-menu__open', function(){
      var menu = $(this).attr('data-menu');
      $(menu).toggleClass('js-menu__expanded');
      $(menu).parent().toggleClass('js-menu__expanded');
       $('body').addClass('over_hide');                            
    });
    
    $(document).on('click', '.js-menu__context',  function(event){
    $('body').removeClass('over_hide');   
      if ( $(event.target).hasClass('js-menu__context') || $(event.target).hasClass('js-menu__close') ) {
      $('.js-menu__expanded').removeClass('js-menu__expanded');
      }
    });

  $(document).on('click', '.js-menu__close', function(event){
     $('body').removeClass('over_hide'); 
      $('.js-menu__expanded').removeClass('js-menu__expanded');
       $('.js-menu__open').removeClass('js-menu__expanded');                                   
    });


// document.addEventListener('DOMContentLoaded', function() {
//   const sortSelect = document.querySelector('.facet-filters__field .select.sort_select_cstm_class');
//   sortSelect.addEventListener('click', function() {
//     sortSelect.classList.toggle('active');
//   });
// });

